import TextViewer from "../../components/TextViever";

const Investor = () => {
  return <TextViewer obszar="investor" />;
};

export default Investor;
